import React, { useEffect, useReducer, useState, useContext } from 'react'

import {
    Dialog, DialogActions, DialogContent, DialogTitle, Divider, Tooltip, Button
    , FormControl, InputLabel, Select, MenuItem, Box, TextField, FormControlLabel, Switch, Checkbox,
    IconButton
} from '@mui/material'
import CloseIcon from '@mui/icons-material/Close'
import defaultReducer from '../../../../../utils/defaultReducer'
import { getSession } from '../../../../../auth'
import api from '../../../../../api'
import LoadingButton from '@mui/lab/LoadingButton';
import style from './styles.module.css'
import { ScreenContext } from '../../..'
import useNotification from '../../../../Notification'
import Loading from '../../../../Loading'
import { Dropdown } from '../../../Templates/ParameterFiller'
import EmailFooter from '../../../../Chat/MessagesArea/ChatWindow/EmailFooter'
import VariableTextField from '../../../../Input/VariableTextField'
import { mimeTypes } from '../../../../Settings/Email/AttachmentsDialog/mimetypes'
import { getAttachments } from '../../../../Chat/MessagesArea/ChatWindow/MessageItem'
import GestureIcon from '@mui/icons-material/Gesture';
import AddSignatureDialog from '../../../../Settings/Email/AddSignatureDialog'
import PredefinedMessageDialog from '../../../../Dialogs/PredefinedMessageDialog'

const enterpriseId = getSession()?.profile?.enterprise?.id

const getEmailConfs = async (setState, setLoading) => {
    setLoading(true)
    const res = await api.get(`/api/enterprises/${enterpriseId}/email/data/`)
    setLoading(false)
    if (res.status === 200)
        return setState({ config: res.data })
    return false
}

export const postEmailAttachments = async (message, attachments, sender) => {
    const data = new FormData()
    attachments.map(each => data.append('files', each))
    data.append('sender', sender)
    const res = await api.post(`/api/enterprises/${enterpriseId}/email/attachments/`, data, { timeout: 30000 })
    if (res.status === 200) {
        message += res.data.join('')
    }
    else if (res.status === 400) {
        const res_message = JSON.parse(res.data.join(''))
        const type = res_message.type
        const extension = mimeTypes[res_message.type] || res_message.type
        useNotification(
            'Erro!',
            res_message.msg.replace(type, extension),
            'danger'
        );
        return -1
    }
    else {
        useNotification(
            'Erro!',
            'Ocorreu um erro ao importar os anexos.',
            'danger'
        );
        return -1
    }

    return message
}

const submit = async (emailMessageData, state, close, setLoading, selectedTemplate = null) => {

    if (emailMessageData && emailMessageData.attachments?.length) {
        emailMessageData.bodyTextContent = await postEmailAttachments(emailMessageData.bodyTextContent, emailMessageData.attachments, state.email)
        if (emailMessageData.bodyTextContent === -1) {
            return -1
        }

    }

    setLoading(true)
    const res = await api.post(
        `/api/enterprises/${enterpriseId}/email/notification/`,
        {
            ...emailMessageData,
            ...state,
            clients: state.clients,
            template_id: selectedTemplate?.id
        })
    setLoading(false)
    
    if (res.status === 200) {
        useNotification(
            'Sucesso!',
            'Email enviado aos contatos selecionados.',
            'success'
        );
        close()
        return
    }
    useNotification(
        'Ops!',
        res.data?.message || 'Email não enviado.',
        'danger'
    );
}

export const ShouldSendEmail = (state) => {
    const message = []

    if (state.email === '')
        message.push(<Box>Obrigatório escolher caixa de e-mail.</Box>)

    if (message.length === 0)
        return ''
    return message
}

export const getEmailDefaultState = {
    clients: [],
    subject: '',
    cc: '',
    cco: '',
    msg: '',
    email: '',
    config: [],
    queue: '',
    agent: getSession()?.profile?.agent?.user,
    emailMessageData: {},
    sendSignature: false,
    signatureAppendix: () => { }
}

const SignatureDialog = ({ id, handleClose, setLoading }) => {

    const [signature, setSignature] = useState(null)

    useEffect(() => {
        const getSignature = async () => {
            setLoading(true)
            const res = await api.get(`/api/enterprises/${enterpriseId}/email/${id}/signature/`)
            setLoading(false)
            if (res.status === 200)
                setSignature(res.data)
            else {
                handleClose()
                useNotification(
                    'Ops!',
                    'Não há assinatura cadastrada',
                    'danger'
                )
            }
        }; getSignature()
    }, [])

    return (
        <>{signature && <AddSignatureDialog data={signature} handleClose={handleClose} submit={null} viewMode={true} />}</>
    )
}

export const SignatureAppendix = ({ parent, setParent, setLoading=()=>{} }) => {

    const [showSignature, setShowSignature] = useState(false)

    const enableSignature = parent.config?.find(config => config.id === parent.email)?.has_signature || false

    return (
        <>
            {showSignature && <SignatureDialog id={parent.email} handleClose={() => setShowSignature(false)} setLoading={setLoading} />}
            <Box className={style.signature}>
                <FormControlLabel
                    label="Assinatura"
                    disabled={!enableSignature}
                    className={style.signatureLabel}
                    control={
                        <Switch
                            checked={parent.sendSignature}
                            onChange={() => {
                                setParent({ sendSignature: !parent.sendSignature })
                            }}
                        />
                    }
                />
                <Tooltip title='Ver assinatura'>
                    <span>
                        <IconButton color="primary" variant='contained'
                            disabled={!enableSignature}
                            onClick={() => setShowSignature(true)}>
                            <GestureIcon />
                        </IconButton>
                    </span>
                </Tooltip>
            </Box>
        </>
    )
}

export const SendEmailContent = ({
    setLoading,
    parent,
    setParent,
    queues,
    emailMessageData,
    canCopy = true,
    contentOnly = true,
    showPredefinedMessages = null,
    usePredefinedMessageEmail = null,
    opportunityCustomFields = null,
    forceEmailCcCco = null,
    setForceEmailCcCco = null,
    emailTemplates = [],
    selectedTemplate = null,
    onEmailTemplateChange = () => {},
}) => {

    const [ready, setReady] = useState(false)
    const [copy, showCopy] = useState(false)

    useEffect(() => {
        getEmailConfs(setParent, setLoading)
    }, [])

    useEffect(() => {
        if ('setEmailData' in window) {
            window.setEmailData(parent.emailMessageData)
            setReady(true)
        }
    }, [parent])

    return (
        <>
            <FormControl fullWidth size="small">
                <InputLabel id="email-simple-select-label">Origem</InputLabel>
                <Select
                    labelId="email-simple-select-label"
                    id="email-simple-select"
                    label="Origem"
                    onChange={({ target }) => {
                        const setparent = { email: target.value }
                        setparent.sendSignature = parent.config.find(config => config.id === target.value)?.has_signature || false
                        setParent(setparent)
                    }}
                    value={parent.email}
                    size='small'
                >
                    {parent.config.filter((row) => row.user_id === null || row.user_id === getSession().id).map(({ id, imap_username, smtp_username, from_address }) => (
                        <MenuItem key={`${id}-select-email`} value={id}>{from_address || smtp_username || imap_username}</MenuItem>
                    ))}
                </Select>
                {(canCopy && !copy) && <Button sx={{ alignSelf: 'self-end' }} onClick={() => showCopy(true)}>CC e CCO</Button>}
            </FormControl>
            <FormControl fullWidth size="small">
                <InputLabel id="email-template-select-label">
                    Modelo de e-mail
                </InputLabel>

                <Select
                    labelId="email-template-select-label"
                    id="email-template-select"
                    label="Modelo de e-mail"
                    value={selectedTemplate?.id != null ? String(selectedTemplate.id) : ''}
                    onChange={({ target }) => onEmailTemplateChange(target.value)}
                >
                    <MenuItem value="">-</MenuItem>

                    {emailTemplates.map((template) => (
                        <MenuItem
                            key={template.id}
                            value={String(template.id)}
                        >
                            {template.name}
                        </MenuItem>
                    ))}
                </Select>
            </FormControl>
            {copy &&
                <>
                    <VariableTextField
                        label='Cópia'
                        sx={{ width: '100%' }}
                        value={parent.cc || ''}
                        onChange={({ target }) => setParent({ cc: target.value })}
                        onVariableSelect={(value) => setParent({ cc: `${parent.cc || ''} ${value}` })}
                        size='small'
                        inputProps={{
                            maxLength: 5000
                        }}
                        opportunityCustomFields={opportunityCustomFields}
                    />
                    <VariableTextField
                        label='Cópia Oculta'
                        sx={{ width: '100%' }}
                        value={parent.cco || ''}
                        onChange={({ target }) => setParent({ cco: target.value })}
                        onVariableSelect={(value) => setParent({ cco: `${parent.cco || ''} ${value}` })}
                        size='small'
                        inputProps={{
                            maxLength: 5000
                        }}
                        opportunityCustomFields={opportunityCustomFields}
                    />
                    {setForceEmailCcCco && <Box>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={Boolean(forceEmailCcCco)}
                                    onChange={({ target }) => setForceEmailCcCco(target.checked)}
                                />
                            }
                            label="Forçar envio de CC e CCO"
                        />
                        <Box sx={{ color: 'text.secondary', fontSize: '0.75rem', marginLeft: '2.5rem', marginTop: '-0.5rem' }}>
                            Quando habilitado, os endereços configurados em CC e CCO receberão uma cópia de cada e-mail enviado pela campanha.
                        </Box>
                    </Box>}
                </>
            }
            <VariableTextField
                label='Assunto'
                sx={{ width: '100%' }}
                value={parent.subject}
                onChange={({ target }) => setParent({ subject: target.value })}
                onVariableSelect={(value) => setParent({ subject: `${parent.subject} ${value}` })}
                size='small'
                inputProps={{
                    maxLength: 100
                }}
                opportunityCustomFields={opportunityCustomFields}
                disabled={Boolean(selectedTemplate)}
            />
            <EmailFooter
                asBuiltIn={(data) => {
                    if (ready)
                        emailMessageData(data)
                }}
                showPredefinedMessages={showPredefinedMessages}
                usePredefinedMessageEmail={usePredefinedMessageEmail}
                opportunityCustomFields={opportunityCustomFields}
                readOnly={Boolean(selectedTemplate)}
            />

            {contentOnly && <SignatureAppendix parent={parent} setParent={setParent} setLoading={setLoading}/>}
        </>
    )
}


const SendEmail = ({ title, handleClose, clients, queues, positionFixed, setup = null, canCopy = true, opportunity_id = null }) => {

    const [state, setState] = useReducer(defaultReducer, {
        ...getEmailDefaultState,
        clients: clients,
        opportunity_id: opportunity_id
    })

    const shouldSendEmail = ShouldSendEmail(state)

    const [loading, setLoading] = useState(false)
    const [showPredefinedMessages, setShowPredefinedMessages] = useState(false)
    const [predefinedMessages, setPredefinedMessages] = useState({})

    const [emailTemplates, setEmailTemplates] = useState([])
    const [selectedTemplate, setSelectedTemplate] = useState(null)

    const userId = getSession()?.id

    const fetchPredefinedMessages = async () => {
        const ent_mes = api.get(`/api/enterprises/${enterpriseId}/predefinedmessages/`)
        const usr_mes = api.get(`/api/users/${userId}/predefinedmessages/`)

        const [ent_res, usr_res] = await Promise.all([ent_mes, usr_mes])
        let predefinedData = {}

        if (usr_res.status == 200) {
            predefinedData = { ...predefinedData, ...usr_res.data }
        }

        if (ent_res.status == 200) {
            ent_res.data.map(each => {
                const cat = `${each.category} - Geral`
                if (cat in predefinedData)
                    predefinedData[cat].push({
                        id: each.id,
                        message: each.message,
                        queue_id: each.queue_id,
                        queue_ids: each.queue_ids,
                        is_html: each.is_html,
                        title: each.title
                    })
                else
                    predefinedData[cat] = [{
                        id: each.id,
                        message: each.message,
                        queue_id: each.queue_id,
                        queue_ids: each.queue_ids,
                        is_html: each.is_html,
                        title: each.title
                    }]
            })
        }

        setPredefinedMessages(predefinedData)
    }

    const addPredefinedMessage = async (message, category, queue = 0) => {
        let data = null;
        const queueSelection = Array.isArray(queue)
            ? queue
            : (queue && typeof queue === 'object' && Array.isArray(queue.queue_ids))
                ? queue.queue_ids
                : [queue && typeof queue === 'object' ? queue.queue_id : queue];
        const normalizedQueueIds = [...new Set(
            queueSelection
                .map((value) => Number(value))
                .filter((value) => !Number.isNaN(value) && value > 0)
        )];
        const payload = {
            message: message,
            category: category,
            queue_ids: normalizedQueueIds,
            queues: normalizedQueueIds
        };

        if (normalizedQueueIds.length === 0) {
            payload.queue_id = 0;
        } else if (normalizedQueueIds.length === 1) {
            payload.queue_id = normalizedQueueIds[0];
        }

        await api.post(`api/users/${userId}/predefinedmessages/`, payload).then(async (res) => {
            if (res.status === 201) {
                data = res.data;
                useNotification(
                    'Sucesso!',
                    'Mensagem predefinida cadastrada com sucesso.',
                    'success'
                );
                fetchPredefinedMessages()
            }
        }).catch(async (err) => {
            console.error(err);
        });

        return data;
    }

    const updatePredefinedMessage = (message) => {
        api.patch(`api/users/${userId}/predefinedmessages/${message.id}/`, {
            message: message.message
        }).then((res) => {
            if (res.status === 200) {
                useNotification(
                    'Sucesso!',
                    'Mensagem predefinida alterada com sucesso.',
                    'success'
                );
                fetchPredefinedMessages()
            }
        }).catch((err) => {
            console.error(err);
        });
    }

    const removePredefinedMessage = (message) => {
        api.delete(`api/users/${userId}/predefinedmessages/${message.id}/`)
            .then((res) => {
                if (res.status === 204) {
                    useNotification(
                        'Sucesso!',
                        'Mensagem predefinida excluída com sucesso.',
                        'success'
                    );
                    fetchPredefinedMessages()
                }
            })
            .catch((err) => {
                console.error(err);
            });
    }

    const usePredefinedMessageEmail = (message) => {
        const htmlMessage = message.replace(/\n/g, '<br>');
        if (window.setEmailPredefinedMessage) {
            window.setEmailPredefinedMessage(htmlMessage);
        }
    }

    const fetchEmailTemplates = async () => {
        const enterpriseId = getSession().profile.enterprise.id
        const response = await api.get(`api/enterprises/${enterpriseId}/email_templates/`)
        if (response.status === 200) {
            setEmailTemplates(response.data)
        }
    }

    useEffect(() => {
        fetchPredefinedMessages()
        fetchEmailTemplates()
    }, [])

    useEffect(() => {
        if (window?.activity?.email) {

            const attachmentregex = /\(emailattachment\)([\s\S]*?)\(\/emailattachment\)/g
            const data = window.activity.email
            const attachments_obj = getAttachments(attachmentregex, data.emailMessageData.bodyTextContent)
            data.emailMessageData.bodyTextContent = attachments_obj.response
            data.emailMessageData.attachments = [...attachments_obj.data.map(each => ({ ...each, loaded: true })), ...(data.emailMessageData.attachments || [])]
            const {clients, ...oldata} = data
            setState(oldata)

            window.setEmailData(data.emailMessageData)
        }
    }, [])

    const handleEmailTemplateChange = (templateId) => {
        if (!templateId) {
            setSelectedTemplate(null);
            setState({ subject: '' });

            if (typeof window.setCleanEmailPredefinedMessage === 'function') {
                window.setCleanEmailPredefinedMessage('');
            }
            
            return;
        }

        const template = emailTemplates.find(
            (item) => String(item.id) === String(templateId)
        );

        if (!template) return;

        setSelectedTemplate(template);

        setState({
            subject: template.subject || '',
        });

        let content = template.html_content || '';

        if (template.content_type === 'text') {
            content = content
                .replace(/&/g, '&amp;')
                .replace(/</g, '&lt;')
                .replace(/>/g, '&gt;')
                .replace(/"/g, '&quot;')
                .replace(/'/g, '&#39;')
                .replace(/\r\n|\r|\n/g, '<br>');
        }

        if (window.setCleanEmailPredefinedMessage) {
            window.setCleanEmailPredefinedMessage(content);
        }
    }

    return (
        <>
            <Loading loading={loading} />
            <Dialog
                open={true}
                disablePortal
                disableEnforceFocus
                onClose={() => { }}
                sx={{ position: positionFixed ? 'fixed' : 'absolute' }}
                fullWidth
                maxWidth="sm"
            >
                <DialogTitle sx={{ display: "flex", justifyContent: "space-between" }}>
                    <span>{title ? title : "Enviar e-mail aos contatos selecionados"}</span>
                    <Tooltip title="Fechar" >
                        <Button className="action-button">
                            <CloseIcon onClick={handleClose} />
                        </Button>
                    </Tooltip>
                </DialogTitle>
                <Divider />
                <DialogContent className={style.defaultSpacing}>
                    <SendEmailContent
                        contentOnly={false}
                        canCopy={canCopy}
                        setLoading={setLoading}
                        parent={state}
                        setParent={setState}
                        queues={queues}
                        emailMessageData={(data) => { state.emailMessageData = data }}
                        showPredefinedMessages={() => setShowPredefinedMessages(true)}
                        usePredefinedMessageEmail={usePredefinedMessageEmail}
                        emailTemplates={emailTemplates}
                        selectedTemplate={selectedTemplate}
                        onEmailTemplateChange={handleEmailTemplateChange}
                    />
                </DialogContent>
                <DialogActions>
                    <SignatureAppendix parent={state} setParent={setState} setLoading={setLoading}/>
                    <LoadingButton
                        onClick={handleClose}
                        color="primary"
                    >
                        Cancelar
                    </LoadingButton>
                    <Tooltip title={shouldSendEmail} placement="top" describeChild={true}>
                        <span><LoadingButton
                            onClick={() => {

                                if (!state.emailMessageData?.bodyTextContent || state.emailMessageData?.bodyTextContent === '') {
                                    useNotification(
                                        'Ops!',
                                        'Não envie e-mails com corpo vazio!',
                                        'warning'
                                    );
                                    return
                                } else if (!state.subject || state.subject === '') {
                                    useNotification(
                                        'Ops!',
                                        'Não envie e-mails com assunto vazio!',
                                        'warning'
                                    );
                                    return
                                }

                                if (setup) {
                                    setup(state);
                                    handleClose()
                                    return
                                }
                                submit(state.emailMessageData, state, handleClose, setLoading, selectedTemplate)
                            }}
                            color="primary"
                            disabled={shouldSendEmail}
                        >
                            {setup ? 'Salvar' : 'Enviar'}
                        </LoadingButton></span>
                    </Tooltip>
                </DialogActions>
            </Dialog>
            <PredefinedMessageDialog 
                open={showPredefinedMessages}
                title="Mensagens Predefinidas"
                predefinedMessages={predefinedMessages}
                addPredefinedMessage={addPredefinedMessage}
                updatePredefinedMessage={updatePredefinedMessage}
                removePredefinedMessage={removePredefinedMessage}
                usePredefinedMessage={usePredefinedMessageEmail}
                activeChat={{}}
                handleClose={() => setShowPredefinedMessages(false)}
            />
        </>
    )
}

export default SendEmail
